// extracted by mini-css-extract-plugin
module.exports = {"sponsors":"SponsorSection_sponsors__28VZg","sponsor":"SponsorSection_sponsor__3EXUM","logos":"SponsorSection_logos__8-uP2"};